export const hasId = <T extends { _id?: string }>(
  m: T
): m is T & { _id: string } => {
  return typeof m._id === "string" && m._id.length > 0;
};
